import * as React from "react";
const IconPlanPurchase = (props) => (
  <svg
    width={25}
    height={25}
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17.0908 7.69232L7.09082 7.69232"
      stroke="#1C1C2C"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.0908 11.6923L7.09082 11.6923"
      stroke="#1C1C2C"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.0908 15.6923L7.09082 15.6923"
      stroke="#1C1C2C"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.0908 2.69232H5.09082C3.98625 2.69232 3.09082 3.58775 3.09082 4.69232V19.8467C3.09082 21.2319 4.46494 22.1976 5.76826 21.7284L7.33002 21.1662C7.81803 20.9905 8.35521 21.0113 8.82819 21.2241L11.2701 22.323C11.792 22.5579 12.3896 22.5579 12.9116 22.323L15.3534 21.2241C15.8264 21.0113 16.3636 20.9905 16.8516 21.1662L18.4134 21.7284C19.7167 22.1976 21.0908 21.2319 21.0908 19.8467V4.69232C21.0908 3.58775 20.1954 2.69232 19.0908 2.69232Z"
      stroke="#1C1C2C"
      strokeWidth={1.5}
      strokeLinecap="round"
    />
  </svg>
);
export default IconPlanPurchase;
